import { SocketEvent, } from '@debbie/common/dist/web-sockets/index.js';
import { dispatch } from '../internal.js';
import { emitEvent, getCurrentActivities, subscribeToEvent } from '../socket.js';
import * as actionTypes from './activeUsersActionTypes.js';
let itemsToAdd = {};
let itemsToRemove = {};
const newActiveUser = (tenantId, newActiveUsers) => {
    if (!itemsToAdd[tenantId]) {
        itemsToAdd[tenantId] = [];
    }
    if (Array.isArray(newActiveUsers)) {
        itemsToAdd[tenantId].push(...newActiveUsers);
    }
    else {
        itemsToAdd[tenantId].push(newActiveUsers);
    }
    setTimeout(() => {
        if (Object.keys(itemsToAdd).length > 0) {
            dispatch({ type: actionTypes.NEW_ACTIVE_USER, payload: itemsToAdd });
            itemsToAdd = {};
        }
    }, 0);
};
const newUserActivity = async (tenantId, wsId, activity) => {
    // Active user event have to be received before this event
    await new Promise((resolve) => setTimeout(resolve, 250));
    dispatch({
        type: actionTypes.NEW_USER_ACTIVITY,
        payload: { tenantId, wsId, activity },
    });
};
const removeUserActivity = async (tenantId, wsId, data) => {
    // Needs to wait as long as newUserActivity to prevent race condition
    await new Promise((resolve) => setTimeout(resolve, 250));
    dispatch({
        type: actionTypes.REMOVE_USER_ACTIVITY,
        payload: { tenantId, wsId, data },
    });
};
const userLeft = (tenantId, wsId) => {
    if (!itemsToRemove[tenantId]) {
        itemsToRemove[tenantId] = [];
    }
    itemsToRemove[tenantId].push(wsId);
    setTimeout(() => {
        if (Object.keys(itemsToRemove).length > 0) {
            dispatch({ type: actionTypes.USER_LEFT, payload: itemsToRemove });
            itemsToRemove = {};
        }
    }, 10);
};
const resetActiveUsers = () => {
    setTimeout(() => {
        dispatch({
            type: actionTypes.RESET_ACTIVE_USERS,
            payload: {},
        });
        const activities = getCurrentActivities();
        for (const activity of activities) {
            emitEvent(SocketEvent.NEWUSERACTIVITY, activity);
        }
    }, 0);
};
subscribeToEvent(SocketEvent.NEWACTIVEUSERS, newActiveUser);
subscribeToEvent(SocketEvent.CONNECT, resetActiveUsers);
subscribeToEvent(SocketEvent.NEWUSERACTIVITY, newUserActivity);
subscribeToEvent(SocketEvent.REMOVEUSERACTIVITY, removeUserActivity);
subscribeToEvent(SocketEvent.USERLEFT, userLeft);
//# sourceMappingURL=activeUsersActions.js.map